export default __webpack_public_path__ + "static/media/youtube_icon.895f3548.svg";